import { render, staticRenderFns } from "./MyPageItem.vue?vue&type=template&id=89dc2f4e&scoped=true"
import script from "./MyPageItem.vue?vue&type=script&lang=js"
export * from "./MyPageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dc2f4e",
  null
  
)

export default component.exports